import { Domain } from '../types/domain';

// Health/Wellness Domains (16)
const healthDomains: Domain[] = [
  {
    id: 'wellbeingsg',
    hostname: 'wellbeingsingapore.com',
    name: 'Wellbeing Singapore',
    description: 'Your guide to holistic wellness in Singapore',
    logo_path: '/logos/wellbeingsg.png',
    theme: {
      primaryColor: '#3498db',
      secondaryColor: '#2980b9',
      accentColor: '#f39c12',
      backgroundColor: '#f9f9f9',
      textColor: '#333333',
    },
    seo: {
      title: 'Wellbeing Singapore - Your Guide to Holistic Wellness',
      description: 'Discover wellness tips, health advice, and holistic living resources in Singapore',
      keywords: ['wellness', 'singapore', 'health', 'holistic', 'wellbeing'],
      ogImage: '/images/og/wellbeingsg.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sgvitality',
    hostname: 'sgvitality.com',
    name: 'SG Vitality',
    description: 'Energizing health and wellness in Singapore',
    logo_path: '/logos/sgvitality.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#219652',
      accentColor: '#e74c3c',
      backgroundColor: '#f5f5f5',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'SG Vitality - Energizing Health and Wellness in Singapore',
      description: 'Your resource for vitality, energy, and overall wellness in Singapore',
      keywords: ['vitality', 'energy', 'wellness', 'singapore', 'health'],
      ogImage: '/images/og/sgvitality.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sgvitalty',
    hostname: 'sgvitalty.com',
    name: 'SG Vitalty',
    description: 'Your journey to vibrant health in Singapore',
    logo_path: '/logos/sgvitalty.png',
    theme: {
      primaryColor: '#2ecc71',
      secondaryColor: '#27ae60',
      accentColor: '#f1c40f',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'SG Vitalty - Your Journey to Vibrant Health',
      description: 'Find health tips, wellness advice, and vitality resources for Singaporeans',
      keywords: ['vitalty', 'health', 'wellness', 'singapore', 'vibrant'],
      ogImage: '/images/og/sgvitalty.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'thrivesg',
    hostname: 'thrivesingapore.com',
    name: 'Thrive Singapore',
    description: 'Thriving in the lion city through wellness and balance',
    logo_path: '/logos/thrivesg.png',
    theme: {
      primaryColor: '#9b59b6',
      secondaryColor: '#8e44ad',
      accentColor: '#f39c12',
      backgroundColor: '#f6f6f6',
      textColor: '#34495e',
    },
    seo: {
      title: 'Thrive Singapore - Wellness and Balance in the Lion City',
      description: 'Your guide to thriving through wellness and balance in Singapore',
      keywords: ['thrive', 'wellness', 'balance', 'singapore', 'health'],
      ogImage: '/images/og/thrivesg.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sglifebalance',
    hostname: 'sglifebalance.com',
    name: 'SG Life Balance',
    description: 'Finding equilibrium in Singapore\'s fast-paced lifestyle',
    logo_path: '/logos/sglifebalance.png',
    theme: {
      primaryColor: '#1abc9c',
      secondaryColor: '#16a085',
      accentColor: '#e67e22',
      backgroundColor: '#f9f9f9',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'SG Life Balance - Finding Equilibrium in Singapore',
      description: 'Discover resources for work-life balance and wellness in Singapore',
      keywords: ['life balance', 'equilibrium', 'wellness', 'singapore', 'lifestyle'],
      ogImage: '/images/og/sglifebalance.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'lifebalancesg',
    hostname: 'lifebalancesg.com',
    name: 'Life Balance SG',
    description: 'Balancing work, life, and wellness in Singapore',
    logo_path: '/logos/lifebalancesg.png',
    theme: {
      primaryColor: '#16a085',
      secondaryColor: '#1abc9c',
      accentColor: '#d35400',
      backgroundColor: '#f7f7f7',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'Life Balance SG - Work, Life, and Wellness in Singapore',
      description: 'Your source for achieving balance in Singapore\'s fast-paced environment',
      keywords: ['life balance', 'work-life', 'wellness', 'singapore', 'lifestyle'],
      ogImage: '/images/og/lifebalancesg.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sgdailyhealth',
    hostname: 'sgdailyhealth.com',
    name: 'SG Daily Health',
    description: 'Everyday health tips for Singaporeans',
    logo_path: '/logos/sgdailyhealth.png',
    theme: {
      primaryColor: '#3498db',
      secondaryColor: '#2980b9',
      accentColor: '#e74c3c',
      backgroundColor: '#f5f5f5',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'SG Daily Health - Everyday Health Tips for Singaporeans',
      description: 'Your daily dose of health tips, wellness advice, and lifestyle guidance',
      keywords: ['daily health', 'health tips', 'singaporeans', 'wellness', 'everyday'],
      ogImage: '/images/og/sgdailyhealth.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'dailyhealthsg',
    hostname: 'dailyhealthsg.com',
    name: 'Daily Health SG',
    description: 'Singapore\'s source for everyday wellness',
    logo_path: '/logos/dailyhealthsg.png',
    theme: {
      primaryColor: '#2980b9',
      secondaryColor: '#3498db',
      accentColor: '#f1c40f',
      backgroundColor: '#f8f8f8',
      textColor: '#34495e',
    },
    seo: {
      title: 'Daily Health SG - Singapore\'s Source for Everyday Wellness',
      description: 'Daily health tips, wellness advice, and lifestyle guidance for Singaporeans',
      keywords: ['daily health', 'wellness', 'singapore', 'healthy living', 'everyday'],
      ogImage: '/images/og/dailyhealthsg.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'vigorsmile',
    hostname: 'vigorsmile.com',
    name: 'Vigor Smile',
    description: 'Find your smile through vigor and vitality',
    logo_path: '/logos/vigorsmile.png',
    theme: {
      primaryColor: '#e74c3c',
      secondaryColor: '#c0392b',
      accentColor: '#3498db',
      backgroundColor: '#f9f9f9',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'Vigor Smile - Find Your Smile Through Vigor and Vitality',
      description: 'Discover the connection between physical vigor and emotional well-being',
      keywords: ['vigor', 'smile', 'vitality', 'wellness', 'health'],
      ogImage: '/images/og/vigorsmile.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'smilevigor',
    hostname: 'smilevigor.com',
    name: 'Smile Vigor',
    description: 'Smiling through life with vigor and vitality',
    logo_path: '/logos/smilevigor.png',
    theme: {
      primaryColor: '#e74c3c',
      secondaryColor: '#c0392b',
      accentColor: '#3498db',
      backgroundColor: '#f9f9f9',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'Smile Vigor - Smiling Through Life With Vigor and Vitality',
      description: 'Discover the connection between smiling and living with vigor and vitality',
      keywords: ['smile', 'vigor', 'vitality', 'wellness', 'health'],
      ogImage: '/images/og/smilevigor.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sgwellness',
    hostname: 'sgwellness.com',
    name: 'SG Wellness',
    description: 'Your wellness journey in Singapore',
    logo_path: '/logos/sgwellness.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#2ecc71',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'SG Wellness - Your Wellness Journey in Singapore',
      description: 'Your guide to achieving and maintaining wellness in Singapore',
      keywords: ['wellness', 'singapore', 'health', 'lifestyle', 'journey'],
      ogImage: '/images/og/sgwellness.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'wellnesssg',
    hostname: 'wellnesssg.com',
    name: 'Wellness SG',
    description: 'Wellness for Singaporeans',
    logo_path: '/logos/wellnesssg.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#2ecc71',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'Wellness SG - Wellness for Singaporeans',
      description: 'Your guide to achieving and maintaining wellness in Singapore',
      keywords: ['wellness', 'singapore', 'health', 'lifestyle', 'sg'],
      ogImage: '/images/og/wellnesssg.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sghealthplus',
    hostname: 'sghealthplus.com',
    name: 'SG Health Plus',
    description: 'Plus-sized health for Singapore',
    logo_path: '/logos/sghealthplus.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#2ecc71',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'SG Health Plus - Plus-Sized Health for Singapore',
      description: 'Your guide to achieving and maintaining plus-sized health in Singapore',
      keywords: ['health', 'plus', 'singapore', 'lifestyle', 'sg'],
      ogImage: '/images/og/sghealthplus.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'healthplussg',
    hostname: 'healthplussg.com',
    name: 'Health Plus SG',
    description: 'Plus-sized health for Singaporeans',
    logo_path: '/logos/healthplussg.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#2ecc71',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'Health Plus SG - Plus-Sized Health for Singaporeans',
      description: 'Your guide to achieving and maintaining plus-sized health in Singapore',
      keywords: ['health', 'plus', 'singapore', 'lifestyle', 'sg'],
      ogImage: '/images/og/healthplussg.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sgvitalityplus',
    hostname: 'sgvitalityplus.com',
    name: 'SG Vitality Plus',
    description: 'Plus-sized vitality for Singapore',
    logo_path: '/logos/sgvitalityplus.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#2ecc71',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'SG Vitality Plus - Plus-Sized Vitality for Singapore',
      description: 'Your guide to achieving and maintaining plus-sized vitality in Singapore',
      keywords: ['vitality', 'plus', 'singapore', 'lifestyle', 'sg'],
      ogImage: '/images/og/sgvitalityplus.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'vitalityplussg',
    hostname: 'vitalityplussg.com',
    name: 'Vitality Plus SG',
    description: 'Plus-sized vitality for Singaporeans',
    logo_path: '/logos/vitalityplussg.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#2ecc71',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'Vitality Plus SG - Plus-Sized Vitality for Singaporeans',
      description: 'Your guide to achieving and maintaining plus-sized vitality in Singapore',
      keywords: ['vitality', 'plus', 'singapore', 'lifestyle', 'sg'],
      ogImage: '/images/og/vitalityplussg.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sgwellnessplus',
    hostname: 'sgwellnessplus.com',
    name: 'SG Wellness Plus',
    description: 'Plus-sized wellness for Singapore',
    logo_path: '/logos/sgwellnessplus.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#2ecc71',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'SG Wellness Plus - Plus-Sized Wellness for Singapore',
      description: 'Your guide to achieving and maintaining plus-sized wellness in Singapore',
      keywords: ['wellness', 'plus', 'singapore', 'lifestyle', 'sg'],
      ogImage: '/images/og/sgwellnessplus.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'wellnessplussg',
    hostname: 'wellnessplussg.com',
    name: 'Wellness Plus SG',
    description: 'Plus-sized wellness for Singaporeans',
    logo_path: '/logos/wellnessplussg.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#2ecc71',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'Wellness Plus SG - Plus-Sized Wellness for Singaporeans',
      description: 'Your guide to achieving and maintaining plus-sized wellness in Singapore',
      keywords: ['wellness', 'plus', 'singapore', 'lifestyle', 'sg'],
      ogImage: '/images/og/wellnessplussg.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sghealthvitality',
    hostname: 'sghealthvitality.com',
    name: 'SG Health Vitality',
    description: 'Health and vitality for Singapore',
    logo_path: '/logos/sghealthvitality.png',
    theme: {
      primaryColor: '#27ae60',
      secondaryColor: '#2ecc71',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#2c3e50',
    },
    seo: {
      title: 'SG Health Vitality - Health and Vitality for Singapore',
      description: 'Your guide to achieving and maintaining health and vitality in Singapore',
      keywords: ['health', 'vitality', 'singapore', 'lifestyle', 'sg'],
      ogImage: '/images/og/sghealthvitality.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
];

// Property Domains (3)
const propertyDomains: Domain[] = [
  {
    id: 'propertySG',
    hostname: 'propertysg.local',
    name: 'Property SG',
    description: 'Navigate Singapore\'s property landscape',
    logo_path: '/logos/propertysg.svg',
    theme: {
      primaryColor: '#2c3e50',
      secondaryColor: '#34495e',
      accentColor: '#e74c3c',
      backgroundColor: '#f5f5f5',
      textColor: '#333333',
    },
    seo: {
      title: 'Property SG - Navigate Singapore\'s Property Landscape',
      description: 'Your expert guide to navigating Singapore\'s dynamic property market',
      keywords: ['property', 'singapore', 'real estate', 'housing', 'market'],
      ogImage: '/images/og/propertysg.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sgrealEstate',
    hostname: 'sgrealestate.local', // Replace with actual domain when ready
    name: 'SG Real Estate',
    description: 'Expert insights on Singapore real estate',
    logo_path: '/logos/sgrealestate.svg',
    theme: {
      primaryColor: '#1abc9c',
      secondaryColor: '#16a085',
      accentColor: '#f39c12',
      backgroundColor: '#f8f8f8',
      textColor: '#333333',
    },
    seo: {
      title: 'SG Real Estate - Expert Insights on Singapore Real Estate',
      description: 'Professional analysis and advice on Singapore\'s real estate market',
      keywords: ['real estate', 'singapore', 'property', 'investment', 'market'],
      ogImage: '/images/og/sgrealestate.jpg',
    },
    features: {
      commentsEnabled: true,
      newsletterSignup: true,
      darkMode: true,
    },
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
];

// Default fallback domain
const defaultDomain: Domain = {
  id: 'default',
  hostname: 'localhost',
  name: 'Multi-Domain Article Platform',
  description: 'A shared content platform for multiple domains',
  logo_path: '/logos/default.svg',
  theme: {
    primaryColor: '#3498db',
    secondaryColor: '#2980b9',
    accentColor: '#f39c12',
    backgroundColor: '#f9f9f9',
    textColor: '#2c3e50',
  },
  seo: {
    title: 'Multi-Domain Article Platform',
    description: 'A shared content platform serving multiple domains with domain-specific styling',
    keywords: ['articles', 'content', 'multi-domain', 'platform'],
    ogImage: '/images/og/default.jpg',
  },
  features: {
    commentsEnabled: true,
    newsletterSignup: true,
    darkMode: true,
  },
  status: 'active',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString()
};

// Combine all domains
const allDomains: Domain[] = [...healthDomains, ...propertyDomains, defaultDomain];

// Helper to find domain by hostname
export const getDomainByHostname = (hostname: string): Domain | null => {
  // Check for domain simulation in URL
  const urlParams = new URLSearchParams(window.location.search);
  const simulateDomain = urlParams.get('domain');
  
  if (simulateDomain) {
    const domain = allDomains.find(d => d.id === simulateDomain);
    if (domain) {
      console.log('Simulating domain:', domain.id);
      return domain;
    }
  }

  // Handle development environment
  if (hostname === 'localhost' || hostname.includes('127.0.0.1')) {
    return null;
  }
  
  const domain = allDomains.find(d => d.hostname === hostname);
  return domain || null;
};

// Export domain arrays
export { healthDomains, propertyDomains, defaultDomain, allDomains }; 